<ng-container *ngIf="replacingOperatorWithRuleForm !== null && replacingOperatorWithRule !== null">
  <h3 mat-dialog-title i18n>
    Editing
    <eas-editor-eligibility-operator-title [operator]="replacingOperatorWithRule.operator">
    </eas-editor-eligibility-operator-title>
  </h3>
  <mat-dialog-content>
    <form [formGroup]="replacingOperatorWithRuleForm">
      <div class="form-container">
        <ng-container [formGroup]="getFormGroup('operator')">
          <mat-form-field appearance="outline">
            <mat-label i18n>Name</mat-label>
            <input matInput type="text" formControlName="name">
          </mat-form-field>
          <mat-radio-group formControlName="affirmative" style="padding-bottom: 15px">
            <mat-radio-button [value]="true" style="padding-right: 15px" i18n>Affirmative</mat-radio-button>
            <mat-radio-button [value]="false" style="padding-right: 15px" i18n>Negative</mat-radio-button>
          </mat-radio-group>
          <mat-form-field *ngIf="getOperatorFormControl('function')" appearance="outline">
            <mat-label i18n>Child rules connected by</mat-label>
            <mat-select id="operator-function" formControlName="function">
              <mat-option *ngFor="let option of functions" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-checkbox *ngIf="getOperatorFormControl('hideNestedDescriptions')"
            id="hide-nested-descriptions"
            formControlName="hideNestedDescriptions"
            i18n
          >
            Hide nested descriptions
          </mat-checkbox>
        </ng-container>
        <ng-container *ngIf="getFormGroup('rule')" [formGroup]="getFormGroup('rule')">
          <mat-form-field appearance="outline">
            <mat-label i18n>Rule</mat-label>
            <mat-select id="rule-class-name" formControlName="ruleClassName">
              <mat-option *ngFor="let option of rules" [value]="option.className">
                {{ option.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container [ngSwitch]="getRuleFormControl('ruleClassName').value">
            <eas-editor-eligibility-rule-form-has-role *ngSwitchCase="'HasRole'"
              [formGroup]="getRuleFormGroup('hasRole')"
            >
            </eas-editor-eligibility-rule-form-has-role>
            <eas-editor-eligibility-rule-form-has-date-user-field *ngSwitchCase="'HasDateUserField'"
              [formGroup]="getRuleFormGroup('hasDateUserField')"
            >
            </eas-editor-eligibility-rule-form-has-date-user-field>
            <eas-editor-eligibility-rule-form-has-discrete-user-field *ngSwitchCase="'HasDiscreteUserField'"
              [formGroup]="getRuleFormGroup('hasDiscreteUserField')"
            >
            </eas-editor-eligibility-rule-form-has-discrete-user-field>
            <eas-editor-eligibility-rule-form-has-string-user-field *ngSwitchCase="'HasStringUserField'"
              [formGroup]="getRuleFormGroup('hasStringUserField')"
            >
            </eas-editor-eligibility-rule-form-has-string-user-field>
            <eas-editor-eligibility-rule-form-has-relation *ngSwitchCase="'HasRelation'"
              [formGroup]="getRuleFormGroup('hasRelation')"
            >
            </eas-editor-eligibility-rule-form-has-relation>
            <eas-editor-eligibility-rule-form-has-booking-item *ngSwitchCase="'HasBookingItem'"
              [formGroup]="getRuleFormGroup('hasBookingItem')"
            >
            </eas-editor-eligibility-rule-form-has-booking-item>
            <eas-editor-eligibility-rule-form-has-booking-option *ngSwitchCase="'HasBookingOption'"
              [formGroup]="getRuleFormGroup('hasBookingOption')"
            >
            </eas-editor-eligibility-rule-form-has-booking-option>
            <eas-editor-eligibility-rule-form-has-booking-type *ngSwitchCase="'HasBookingType'"
              [formGroup]="getRuleFormGroup('hasBookingType')"
            >
            </eas-editor-eligibility-rule-form-has-booking-type>
            <eas-editor-eligibility-rule-form-has-event *ngSwitchCase="'HasEvent'"
              [formGroup]="getRuleFormGroup('hasEvent')"
            >
            </eas-editor-eligibility-rule-form-has-event>
            <eas-editor-eligibility-rule-form-has-event-count *ngSwitchCase="'HasEventCount'"
              [formGroup]="getRuleFormGroup('hasEventCount')"
            >
            </eas-editor-eligibility-rule-form-has-event-count>
            <eas-editor-eligibility-rule-form-is-raw-operator *ngSwitchCase="'IsRawOperator'"
              [formGroup]="getRuleFormGroup('isRawOperator')"
            >
            </eas-editor-eligibility-rule-form-is-raw-operator>
          </ng-container>
        </ng-container>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button color="primary" [disabled]="replacingOperatorWithRuleForm.invalid" (click)="onSubmit()" i18n>Apply</button>
  </mat-dialog-actions>
</ng-container>
